import { GqlPlannerTravelGroupOwnerBillingType } from "~/__generated__";

// Only travel groups with a car owner can take passengers
const CARPOOLABLE_OWNER_BILLING_TYPES = [
    GqlPlannerTravelGroupOwnerBillingType.PrivateCar,
    GqlPlannerTravelGroupOwnerBillingType.MyWheels,
];

export function isCarpoolableTravelGroup(travelGroup: { ownerBillingType: GqlPlannerTravelGroupOwnerBillingType }) {
    return CARPOOLABLE_OWNER_BILLING_TYPES.includes(travelGroup.ownerBillingType);
}
